import * as React from 'react';
import { IPosition } from '@nkr/models/index';
import { Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PreSelectReversalResponsible } from '@nkr/enums/preselect-reversal-responsible';
import { fileText2 } from 'react-icons-kit/icomoon/fileText2';
import Icon from 'react-icons-kit';
import styled from 'styled-components';
import PopoverTemplate from '@nkr/components/popover-template';

const PopoverWrapper = styled(PopoverTemplate)`
    max-width: 600px;
`;

interface ISwapRowProps {
    index: number,
    position: IPosition,
    include: boolean,
    includeClc: number,
    responsible: string,
    isMatchOffer: boolean,
    isCommencement: boolean,
    showStrongBox: boolean,
    useStrongBox: boolean,
    isCancelSwap: boolean,
    hasPreselectReversal: boolean,
    onIncludeChange: (positionNumber: number, include: boolean) => void,
    onIncludeClcChange: (positionNumber: number, include: number) => void,
    onReversalResponsibleChange: (positionNumber: number, responsible: PreSelectReversalResponsible) => void
    onUseStrongBoxChange: (positionNumber: number, useStrongBox: boolean) => void,
}

const SwapListRow = (props: ISwapRowProps) => {

    const dCenter = props.position.donor.rdnCenter ?? props.position.donor.center;
    const enableStrongBox = dCenter.isActiveStrongBoxCenter && dCenter.id != props.position.recipient.centerId;

    const handleInclude = (e: React.FormEvent<any>) => {
        props.onIncludeChange(props.position.positionNumber, !props.include);
    }

    const handleReversalResponsibleChange = (responsible: PreSelectReversalResponsible) => {
        props.onReversalResponsibleChange(props.position.positionNumber, responsible);
    };

    const handleUseStrongBox = (e: React.FormEvent<any>) => {
        if(enableStrongBox) {
            props.onUseStrongBoxChange(props.position.positionNumber, !props.useStrongBox);
        }
    }


    const includeIcon = props.include ? 'check' : 'unchecked';
    const useSBIcon = props.useStrongBox ? 'check' : 'unchecked';
    
    const matchOfferNotAvailable = props.isMatchOffer && props.position.kidneyPickup == '';
    const reasons = props.position.preselectDeclineReasons;
    const showPSReversalColumns = props.isCancelSwap && props.hasPreselectReversal;

    const declinedPopup = (
        <PopoverWrapper>
            <div style={{ color: 'black', background: 'white', padding: '1rem', borderRadius: '4px' }}>
                <div style={{ marginBottom: 5 }}>
                    <div style={{ marginBottom: '5px' }}>
                        <strong style={{ marginTop: '0.5rem', color: '#c32232', fontSize: '16px' }}>
                            MO Declined Reasons
                        </strong>
                    </div>

                    {reasons && reasons.length > 0 ? (
                        <ul style={{ paddingLeft: '1rem', marginBottom: 0, textAlign: 'left' }}>
                            {reasons.map((r, idx) => (
                                <li key={idx}>
                                    {r.reason == "Other" ? (
                                        <>
                                            <span>Other:</span>{' '}
                                            <span style={{ fontWeight: 'bold' }}>{r.otherText}</span>
                                        </>
                                    ) : (
                                        r.reason
                                    )}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div style={{ textAlign: 'left' }}>No reasons provided</div>
                    )}
                </div>
            </div>
        </PopoverWrapper>
    );


    return (
        <tr style={{ backgroundColor: matchOfferNotAvailable ? 'rgb(255, 0, 0)' : '', color: matchOfferNotAvailable ? 'white' : '' }}>
            <td>{props.position.chainId}/{props.position.clusterNumber}/{props.position.positionNumber}</td>
            <td>
                {props.position.donor.center.alias}{props.position.donor.rdnCenterAlias != '' ? <>&nbsp;(<span style={{ fontSize: 12, color: 'red' }}>{props.position.donor.rdnCenterAlias}</span>)</> : ''}
            </td>
            <td>{props.position.donor.alias}</td>
            {showPSReversalColumns && (
                <td>
                    {props.isCancelSwap && props.position.hasPreselectReversal && (
                        <Glyphicon
                            glyph={props.position.reversalResponsible == PreSelectReversalResponsible.DonorCenter ? 'check' : 'unchecked'}
                            onClick={() => handleReversalResponsibleChange(PreSelectReversalResponsible.DonorCenter)}
                        />
                    )}
                </td>
            )}
            <td>{props.position.recipient.center.alias}</td>
            <td>{props.position.recipient.alias}&nbsp;
                {props.isCancelSwap && props.position.hasPreselectReversal && (
                    <OverlayTrigger
                        rootClose
                        placement='bottom'
                        trigger={['hover', 'focus']}
                        overlay={declinedPopup}
                    >
                        <Icon icon={fileText2} size={14} style={{ color: 'black' }} />
                    </OverlayTrigger>
                )}
            </td>
            {showPSReversalColumns && (
                <td>
                    {props.position.hasPreselectReversal && (
                        <Glyphicon
                            glyph={props.position.reversalResponsible == PreSelectReversalResponsible.RecipientCenter ? 'check' : 'unchecked'}
                            onClick={() => handleReversalResponsibleChange(PreSelectReversalResponsible.RecipientCenter)}
                        />
                    )}
                </td>
            )}
            {props.isCommencement && (
                <td>{props.position.isDataComplete ? <Glyphicon glyph='ok' style={{ color: 'green' }} /> : <Glyphicon glyph='remove' style={{ color: 'red' }} />}</td>
            )}
            <td>
                <Glyphicon glyph={includeIcon} onClick={handleInclude} />
            </td>
            {props.showStrongBox && <td><Glyphicon glyph={useSBIcon} onClick={handleUseStrongBox} style={{ color: enableStrongBox ? 'black' : 'gray' }} /></td>}
        </tr>
    );
}

export default SwapListRow;